import { Link } from 'react-router-dom';
import { categories, categoryImages } from '@/mocks/articles';

export default function CategoryGrid() {
  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium">
            <i className="ri-grid-line w-3 h-3 flex items-center justify-center"></i>
            分类浏览
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mt-4 tracking-tight">
            热门吃瓜分类
          </h2>
          <p className="text-sm text-foreground-500 mt-2 max-w-lg mx-auto">
            按分类快速找到你最想吃的瓜，六大板块全覆盖
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {categories.map((cat) => {
            const img = categoryImages[cat.slug] || categoryImages.wanghong;
            return (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="group relative w-full aspect-[4/3] rounded-xl overflow-hidden"
              >
                <img
                  src={img}
                  alt={cat.name}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-black/10"></div>
                <div className="absolute inset-0 flex flex-col items-center justify-center text-center p-4">
                  <span className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-white/15 backdrop-blur-sm mb-4 group-hover:bg-primary-500/80 transition-all duration-300">
                    <i className={`${cat.icon} text-2xl md:text-3xl text-white`}></i>
                  </span>
                  <h3 className="text-xl md:text-2xl font-heading font-bold text-white tracking-wide">
                    {cat.name}
                  </h3>
                  <p className="text-xs text-white/60 mt-2">
                    {cat.count.toLocaleString()} 条爆料
                  </p>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}